import {gql} from 'apollo-angular';

export const GET_COMPANY_SIZES = gql`
  query GetCompanySizes {
    getCompanySizes {
      id
      name
      text
    }
  }
`;
